import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import SubscribeConfirm from './pages/SubscribeConfirm';
import Unsubscribe from './pages/Unsubscribe';
import AdminLogin from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import CategoryManage from './pages/admin/CategoryManage';
import PostList from './pages/admin/PostList';
import PostEdit from './pages/admin/PostEdit';
import Settings from './pages/admin/Settings';
import SubscriberManage from './pages/admin/SubscriberManage';

export default function App() {
  return (
    <Routes>
      {/* 공개 라우트 */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/posts/:slug" element={<PostDetail />} />
        <Route path="/subscribe/confirm" element={<SubscribeConfirm />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
      </Route>

      {/* 관리자 라우트 */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<PostList />} />
        <Route path="posts" element={<PostList />} />
        <Route path="posts/new" element={<PostEdit />} />
        <Route path="posts/:id/edit" element={<PostEdit />} />
        <Route path="categories" element={<CategoryManage />} />
        <Route path="subscribers" element={<SubscriberManage />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
